// skrývání toolbaru při scrollu o výšku okna
function carAnimation() {
  let scrollValue = $(window).innerHeight() * 0.17;
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= scrollValue) {
      $('.car__no-tyres').css({ top: 'calc(50% - 4%)' });
      $('.car__tyres').css({ top: 'calc(50% + 8.1%)' });
    } else {
      $('.car__no-tyres, .car__tyres').css({ top: '50%' });
    }
  });
}
